import Cookies from 'js-cookie';

import isStringifiedJSONObject from 'utils/isStringifiedJSONObject';
import { getLogger } from 'utils/logger/getLogger';
import stripDoubleQuotes from 'utils/stripDoubleQuotes';

// Utility functions for dealing with browser cookies

/**
 * Deletes ALL document.cookies (does not touch http cookies)
 */

export default Cookies.withConverter({
  read: value => {
    // NOTE: js-cookie converter will not allow a falsy value to be returned in place
    // of a non-falsy value, so we cannot transform 'undefined' to a falsy return value.
    const returnValue = decodeURIComponent(value);

    if (isStringifiedJSONObject(returnValue)) {
      try {
        return JSON.parse(returnValue);
      } catch (error) {
        return stripDoubleQuotes(returnValue);
      }
    }

    return stripDoubleQuotes(returnValue);
  },
  write: value => {
    return value;
  },
});

export const deleteCookies = (cookieNames, optionalAttributes) => {
  if (!Array.isArray(cookieNames) || !cookieNames.length) {
    return;
  }
  // In optionalAttributes you pass the same attributes that were used when
  // the cookie was created and are required when removing the cookie
  try {
    cookieNames.forEach(cookieName => {
      Cookies.remove(cookieName, optionalAttributes);
    });
  } catch (err) {
    const { LOG_LEVELS, loggerHelper } = getLogger();
    loggerHelper({
      level: LOG_LEVELS.WARNING,
      message: 'Could not delete all cookies',
      info: err,
    });
  }
};

export const deleteAllCookies = optionalAttributes => {
  deleteCookies(Object.keys(Cookies.get()), optionalAttributes);
};
